export const messages = {
  en: {
    printerMachine: {
      queryCondition: 'Query Condition',
      query: 'Query',
      printerDevice: 'Printer Device',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      operation: 'Operation',
      cancel: 'Cancel',
      save: 'Save',
      confirmOperation: 'Please confirm your operation!',
      confirmDelete: 'Confirm Delete!',
      confirmDeletePrinter: 'Confirm to delete the printer device',
      deleteSuccess: 'Delete successfully',
      updateSuccess: 'Update successfully',
      saveSuccess: 'Save successfully',
      machineCode: 'Device Code',
      machineType: 'Device Type',
      appId: 'AppId',
      appSecure: 'Secret Key',
      shop: 'Shop',
      machineImpl: 'Device Manufacturer',
      createTime: 'Create Time',
      id: 'ID',
      machineCodePlaceholder: 'Please enter device code',
      machineCodeRequired: 'Device code is required',
      machineTypePlaceholder: 'Please select device type',
      machineTypeRequired: 'Device type is required',
      appIdPlaceholder: 'Please enter AppId',
      appIdRequired: 'AppId is required',
      appSecurePlaceholder: 'Please enter secret key',
      appSecureRequired: 'Secret key is required',
      machineImplPlaceholder: 'Please select device manufacturer',
      machineImplRequired: 'Device manufacturer is required',
      orderPrinter: 'Order Printer',
      yilanyun: 'Yilanyun',
      maxLength64: 'Cannot exceed 64 characters'
    }
  },
  zh: {
    printerMachine: {
      queryCondition: '查询条件',
      query: '查询',
      printerDevice: '打印设备',
      add: '添加',
      edit: '修改',
      delete: '删除',
      operation: '操作',
      cancel: '取消',
      save: '保存',
      confirmOperation: '请确认您的操作!',
      confirmDelete: '确认删除!',
      confirmDeletePrinter: '确定删除打印设备',
      deleteSuccess: '删除成功',
      updateSuccess: '更新成功',
      saveSuccess: '保存成功',
      machineCode: '设备编号',
      machineType: '设备类型',
      appId: 'AppId',
      appSecure: '秘钥',
      shop: '商铺',
      machineImpl: '设备厂家',
      createTime: '创建时间',
      id: '编号',
      machineCodePlaceholder: '请输入设备编号',
      machineCodeRequired: '设备编号不能为空',
      machineTypePlaceholder: '请选择设备类型',
      machineTypeRequired: '设备类型不能为空',
      appIdPlaceholder: '请输入AppId',
      appIdRequired: 'AppId不能为空',
      appSecurePlaceholder: '请输入秘钥',
      appSecureRequired: '秘钥不能为空',
      machineImplPlaceholder: '请选择设备厂家',
      machineImplRequired: '设备厂家不能为空',
      orderPrinter: '订单打印机',
      yilanyun: '易联云',
      maxLength64: '不能超过64个字符'
    }
  }
}